<template lang="html">
  <div id="landingPage">
    <b-row id="row1">
      <b-col lg="4" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(1)" rounded><b-img fluid src="img/STP.png"></b-img></b-button></b-col>
      <b-col lg="4" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(2)"><b-img fluid src="img/ESK.png"></b-img></b-button></b-col>
      <b-col lg="4" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(3)"><b-img fluid src="img/PYM.png"></b-img></b-button></b-col>
    </b-row>
    <b-row id="row2">
      <b-col lg="6" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(4)"><b-img fluid src="img/THN.png"></b-img></b-button></b-col>
      <b-col lg="6" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(5)"><b-img fluid src="img/NMH.png"></b-img></b-button></b-col>
    </b-row>
    <!-- <div class="row" id="row1">
      <div class="col-1">

      </div>
      <div class="col-3">
        ts
      </div>
      <div class="col-3">
        st
      </div>
      <div class="col-3">

      </div>
      <div class="col-1">

      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "LandingPage",
  methods: {
    buttonClicked: function(id) {
      // console.log(id);
      // console.log(this.$router);
      this.$router.push({ name: 'MainApp', params: { activeTab: id } })
    }
  }
}
</script>

<style>
  #landingPage {
    width: 100vw;
    height: 87vh;

    /* background-color: green; */
  }
  #row1 {
    height: 43vh;
  }
  #row2 {
    height: 43vh;
  }
  .bigButton {
    margin-top: 6vh;
    width: 25vw!important;
    height: 25vh!important;
    background: rgba(128, 128, 128, 0.3)
  }
  .bigButton:hover, .bigButton:active {
    background: rgba(128, 128, 128, 0.5)!important;
  }
</style>
